import { IoFilter } from 'react-icons/io5';
import FilterModal from '../../component/FilterModal';
import api from '../../data/api';
import { useEffect, useRef } from 'react';
import TRC_PAGE_CATEGORIES from '@/TRC/constants/trcCategories';
import TRC_FILE_TYPE from '@/TRC/constants/trcFileType';
import { getAvailableDurations } from '@/component/FilterFunction/getAvailableDuration';
import TRC_CONTENT from '@/constants/trcContentType';

const TRCFilterModalWrapper = ({ contents, setContents, contentType, filters, category }) => {

	const {
		instructors,
		setInstructors,
		products,
		selectedTags,
		selectedDurations,
		selectedLevels,
		selectedInstructors,
		selectedProducts,
		sortby,
		handleResetFilter,
		isFilterModalOpen,
		handleOpenFilterModal,
		handleCloseFilterModal,
		setSelectedTags,
		setSelectedProducts,
		setSelectedDurations,
		setSelectedInstructors,
		setIsFilterModalOpen,
		durationValue,
		setDurationValues
	} = filters;

	useEffect(() => {
		if (sortby) {
			handleApplyFilter(selectedTags, selectedDurations, selectedLevels, selectedInstructors, selectedProducts, sortby);
		}
	}, [sortby]);
	const initialInstructorsRef = useRef([]);
	const initialDurationsRef = useRef([]);
	const initialProductsRef = useRef([]);
	const initialFocusRef = useRef([]);

	const allTags = contents?.flatMap(content => content.tagsDetails || []) ?? [];
	const tagsById = new Map(allTags.map(tag => [tag._id, tag]));
	const uniqueTags = [...tagsById.values()];

	const allProductIds = contents?.flatMap(content =>
		(content.productsData || []).map(p => p._id)
	) ?? [];

	const uniqueProductIds = [...new Set(allProductIds)];
	const associatedProducts = products?.filter(product =>
		uniqueProductIds.includes(product.id)
	) ?? [];
	useEffect(() => {
		if (uniqueTags.length > 0 && initialFocusRef.current.length === 0) {
			initialFocusRef.current = uniqueTags;
		}
		if (associatedProducts.length > 0 && initialProductsRef.current.length === 0) {
			initialProductsRef.current = associatedProducts;
		}
	}, [associatedProducts]);

	useEffect(() => {
		const availableDurations = getAvailableDurations(contents);
		setDurationValues(availableDurations);

		if (initialDurationsRef.current.length === 0) {
			initialDurationsRef.current = availableDurations;
		}
		if (contents?.length > 0) {
			const filteredInstructors = [
				...new Set(
					contents
						.filter(content => content.instructor && content.instructor.trim() !== '')
						.map(content => content.instructor)
				)
			];

			if (filteredInstructors.length !== instructors.length) {
				setInstructors(filteredInstructors);
			}
			if (initialInstructorsRef.current.length === 0) {
				initialInstructorsRef.current = filteredInstructors;
			}
		}
	}, [contents, instructors.length, setInstructors]);

	const handleApplyFilter = async (tags, duration, level, instructor, products) => {
		const durationString = Array.isArray(duration) ? duration.join(',') : duration;
		setSelectedTags(tags)
		setSelectedProducts(products)
		setSelectedDurations(duration)
		setSelectedInstructors(instructor)

		const params = {
			type: contentType,
			tags,
			duration: durationString?.toString() ?? '',
			instructor,
			level: level ?? '',
			products,
			sortby,
		};
		if (category && category !== TRC_PAGE_CATEGORIES.VIEW_ALL) {
			params.category = category;
		}
		const response = await api.getContent(params);
		setContents(response.data);
		setIsFilterModalOpen(false)
	};
	const initialHasVideos = useRef(false);
	useEffect(() => {
		if (initialHasVideos.current) return;
		if (!contents?.length) return;

		initialHasVideos.current = contents.some(
			content => content.fileType === TRC_FILE_TYPE.VIDEO
		);
	}, [contents]);

	return (
		<>
			<div
				className="d-flex align-items-center gap-1 mx-1 "
				style={{
					padding: '0.5rem',
					border: '1px solid #3CB4E4',
					borderRadius: '0.5rem'
				}}
				onClick={handleOpenFilterModal}
			>
				<IoFilter size={24} color="#3CB4E4" />
				<span className="sr-only">Filters</span>
			</div>
			<span className="filterby-2">
				{isFilterModalOpen && (
					<FilterModal
						isOpen={isFilterModalOpen}
						tags={initialFocusRef.current.length > 0 ? initialFocusRef.current : uniqueTags}
						durationValue={initialDurationsRef.current.length > 0 ? initialDurationsRef.current : durationValue}
						checkedTags={selectedTags}
						checkedDuration={selectedDurations}
						checkedLevels={selectedLevels}
						handleApplyFilter={handleApplyFilter}
						handleResetFilter={handleResetFilter}
						handleClose={handleCloseFilterModal}
						instructors={initialInstructorsRef.current.length > 0 ? initialInstructorsRef.current : instructors}
						checkedInstructors={selectedInstructors}
						products={initialProductsRef.current.length > 0 ? initialProductsRef.current : associatedProducts}
						checkedProducts={selectedProducts}
						showDurationFilter={initialHasVideos.current}
						showLevelFilter={false}
						contentType={TRC_CONTENT.TRC}
					/>
				)}
			</span>
		</>
	);
};

export default TRCFilterModalWrapper;
